<template>
    <DModal
        :show="showModal"
        :title="__('orders.show.agency_modal.title')"
        overflow-auto
        is-confirm
        :is-awaiting-validation="true"
        @close="$emit('close', segmentsData)"
        @confirm="confirm"
    >
        <DCard
            padding
            class="min-height"
        >
            <DRow>
                <DCol sm="7">
                    <DMultiSelect
                        id="segments-dropdown"
                        :options="segmentOptions"
                        :search="true"
                        :selection="true"
                        :options-empty-placeholder="__('orders.show.agency_modal.customer_segments')"
                        selection-type="text"
                        :label="__('orders.show.agency_modal.customer_segments')"
                        @update="updateSelectedSegments"
                    />
                    <p
                        v-for="(error, index) in errorsData"
                        :key="index"
                        class="error-msg"
                    >
                        <span v-if="error.segments">{{ error }}</span>
                    </p>
                </DCol>
                <DCol
                    sm="5"
                    class="text-end find-btn"
                >
                    <DButton
                        id="find-customer"
                        icon="magnify"
                        :label="__('orders.show.agency_modal.find_customer')"
                        @click="findCustomer()"
                    />
                </DCol>
            </DRow>
            <DRow class="pt-4">
                <DCol sm="12">
                    <DMultiSelect
                        id="customers-dropdown"
                        :options="customers"
                        :search="true"
                        :selection="true"
                        :multiple="false"
                        :options-empty-placeholder="__('orders.show.agency_modal.customers')"
                        selection-type="text"
                        :label="__('orders.show.agency_modal.customers')"
                        @update="updateCustomer"
                    />
                </DCol>
            </DRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    segments: {
        type: Array,
        default () {
            return []
        }
    },
    selectedSegments: {
        type: Array,
        default () {
            return []
        }
    }
})

const emit = defineEmits(['close', 'confirm'])

const segmentsData = ref(props.selectedSegments)
const customers = ref([])
const errorsData = ref([])
const formAgency = useForm({
    customer_id: '',
    order_id: ''
})

const segmentOptions = computed(() => {
    return props.segments.map((item) => {
        return { value: item.value, text: item.label, selected: props.selectedSegments.includes(String(item.value)) }
    })
})

function updateSelectedSegments (values) {
    segmentsData.value = values
}

function updateCustomer (values) {
    formAgency.customer_id = values[0]
}

onMounted(async () => {
    if (segmentsData.value.length > 0) {
        findCustomer()
    }
})

function findCustomer () {
    errorsData.value = []

    window.axios.get(route('orders.psa.find-agency-customers', {
        segments: segmentsData.value
    }))
        .then((response) => {
            customers.value = response.data.customers
        })
        .catch((error) => {
            if (error && error.response && error.response.data.errors !== undefined) {
                const errorObject = error.response.data.errors

                Object.keys(errorObject).forEach((field) => {
                    errorObject[field].forEach((message) => {
                        errorsData.value.push(message)
                    })
                })
            }
        })
}

function confirm () {
    emit('confirm', formAgency)
}

</script>

<style scoped lang="scss">
.min-height {
    min-height: 250px;
}
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    text-align: left;
    color: var(--colorDanger);
}
.find-btn {
    padding-top: 20px;
}
</style>
